import { StoreLocaleCodeSchema, type LocaleCode } from './types';

export function isStoreLocaleCode(code: string): code is LocaleCode {
   return StoreLocaleCodeSchema.safeParse(code).success;
}
